module.exports = __webpack_public_path__ + "23_bigdata_4.jpg?536ad9c821836b7d67ef31df7ecdfd53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_bigdata_4.jpg
// module id = 195
// module chunks = 0